import * as types from './compositionActionTypes';

export const getCompositionRequestAction = (payload) => ({
  type: types.GET_COMPOSITION_REQUEST,
  payload,
});

export const getCompositionDataAction = (payload) => ({
  type: types.GET_COMPOSITION_DATA,
  payload,
});

export const getCompositionErrorAction = (payload) => ({
  type: types.GET_COMPOSITION_ERROR,
  payload,
});

export const createCompositionRequestAction = (payload) => ({
  type: types.CREATE_COMPOSITION_REQUEST,
  payload,
});

export const createCompositionDataAction = (payload) => ({
  type: types.CREATE_COMPOSITION_DATA,
  payload,
});

export const createCompositionErrorAction = (payload) => ({
  type: types.CREATE_COMPOSITION_ERROR,
  payload,
});

export const updateCompositionRequestAction = (payload) => ({
  type: types.UPDATE_COMPOSITION_REQUEST,
  payload,
});

export const updateCompositionDataAction = (payload) => ({
  type: types.UPDATE_COMPOSITION_DATA,
  payload,
});

export const updateCompositionErrorAction = (payload) => ({
  type: types.UPDATE_COMPOSITION_ERROR,
  payload,
});

export const deleteCompositionRequestAction = (payload) => ({
  type: types.DELETE_COMPOSITION_REQUEST,
  payload,
});

export const deleteCompositionDataAction = (payload) => ({
  type: types.DELETE_COMPOSITION_DATA,
  payload,
});

export const deleteCompositionErrorAction = (payload) => ({
  type: types.DELETE_COMPOSITION_ERROR,
  payload,
});